import * as React from "react";
import type { SVGProps } from "react";
const Hospital = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4369_3165)">
      <g clipPath="url(#clip1_4369_3165)">
        <path
          fill="currentColor"
          d="M7.2 4.1994c0-.9937.8062-1.8 1.8-1.8h6c.9938 0 1.8.8063 1.8 1.8v17.4h-3v-3c0-.9937-.8062-1.8-1.8-1.8s-1.8.8063-1.8 1.8v3h-3zm-5.4 1.8H6v15.6H1.8c-.9937 0-1.8-.8062-1.8-1.8v-5.4h3c.33 0 .6-.27.6-.6s-.27-.6-.6-.6H0v-2.4h3c.33 0 .6-.27.6-.6s-.27-.6-.6-.6H0v-1.8c0-.9937.8063-1.8 1.8-1.8m20.4 0c.9938 0 1.8.8063 1.8 1.8v1.8h-3c-.33 0-.6.27-.6.6s.27.6.6.6h3v2.4h-3c-.33 0-.6.27-.6.6s.27.6.6.6h3v5.4c0 .9938-.8062 1.8-1.8 1.8H18v-15.6zm-10.5-1.2c-.33 0-.6.27-.6.6v.9h-.9c-.33 0-.6.27-.6.6v.6c0 .33.27.6.6.6h.9v.9c0 .33.27.6.6.6h.6c.33 0 .6-.27.6-.6v-.9h.9c.33 0 .6-.27.6-.6v-.6c0-.33-.27-.6-.6-.6h-.9v-.9c0-.33-.27-.6-.6-.6z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4369_3165">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="clip1_4369_3165">
        <path fill="transparent" d="M0 2.3999h24v19.2H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default Hospital;
